"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _dispositionl = require("@/api/dispositionl");
var _ossUpload = require("@/utils/ossUpload");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _member = require("@/api/member/member");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { upData } from '@/api/marketingFunction/marketingEvents'
var _default = exports.default = {
  name: 'HierarchicalAllocation',
  data: function data() {
    return {
      // label-width距离尺寸
      marginWidth: '170px',
      marginWidth1: '140px',
      tableLoading: false,
      tableData: [],
      // 弹窗
      dialogVisible: false,
      // 新增
      conditionsListData: [{
        name: '用户条件+',
        color: '#7EB6F5',
        id: 1
      }, {
        name: '订单条件+',
        color: '#0CC6BF',
        id: 2
      }, {
        name: '收益条件+',
        color: '#F59A23',
        id: 3
      }, {
        name: '充值条件+',
        color: '#D4484B',
        id: 4
      }],
      UnitType: {
        '1': {
          title: '用户',
          unit: '人',
          dimension: '180px',
          selectDataName: 'userData'
        },
        '2': {
          title: '订单',
          unit: '笔',
          dimension: '360px',
          selectDataName: 'orderData'
        },
        '3': {
          title: '收益',
          unit: '元',
          dimension: '180px',
          selectDataName: 'earningsData'
        },
        '4': {
          title: '充值',
          unit: '元',
          dimension: '540px',
          selectDataName: 'topUpData'
        }
      },
      ConditionType: {
        '1': {
          type: 1,
          time: null,
          rela: null,
          item: null,
          value: null
        },
        '2': {
          type: 2,
          time: null,
          item: null,
          value: null
        },
        '3': {
          type: 3,
          rela: null,
          item: null,
          value: null
        },
        '4': {
          type: 4,
          item: null,
          value: null
        }
      },
      // 是否可以选择满足
      conditionTrueIsNoList: {
        '1': false,
        '2': false,
        '3': false
      },
      // 下拉框集合
      selectData: {
        userData: {
          itemLimit: [],
          relationLimit: [],
          timeLimit: []
        },
        orderData: {
          itemLimit: [],
          relationLimit: [],
          timeLimit: []
        },
        earningsData: {
          itemLimit: [],
          relationLimit: [],
          timeLimit: []
        },
        topUpData: {
          itemLimit: [],
          relationLimit: [],
          timeLimit: []
        }
      },
      ruleForm: {
        status: 0,
        // 状态
        name: '',
        // 等级名称
        grade: '',
        // 权重
        icon: '',
        // 图片
        selfUpgrade: 1,
        // 用户自助升级 0-不允许 1-允许
        upgradeMethod: 0,
        // 升级方式 0-默认升级 1-自定义升级
        targetGrade: null,
        // 升级的目标等级
        teamShare: null,
        // 团队分佣 0-禁止团队分佣 1-启用团队分佣
        benefitImage: '',
        // 权益图
        upgradeModel: 1,
        // 条件模式
        upgradeTips: '',
        // 说明
        conditionList: [{
          enable: 0,
          index: 1,
          model: null,
          termList: []
        }, {
          enable: 0,
          index: 2,
          model: null,
          termList: []
        }, {
          enable: 0,
          index: 3,
          model: null,
          termList: []
        }],
        selfRate: '',
        // 自购分佣
        subRate: '',
        directRate: null,
        // 直属上级

        teamRate: 0,
        // 团队分佣1
        lateralRateList: [{
          id: 1,
          order: 1,
          // 位置
          rate: 0 // 比例
        }, {
          id: 2,
          order: 2,
          rate: 0
        }, {
          id: 3,
          order: 3,
          rate: 0
        }],
        teamPlusRate: 0,
        // 团队分佣2
        lateralPlusRateList: [{
          id: 4,
          // 索引表示key
          order: 1,
          rate: 0
        }, {
          id: 5,
          order: 2,
          rate: 0
        }, {
          id: 6,
          order: 3,
          rate: 0
        }],
        plusModel: null // 分佣配置模式:0-团队分佣配置1,1-团队分佣配置2
      },
      rules: {
        // status: [
        //   { required: true, message: '请选择等级状态', trigger: 'change' }
        // ],

        name: [{
          required: true,
          message: '请输入等级名称',
          trigger: 'blur'
        }],
        grade: [{
          required: true,
          message: '请输入等级权重',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请输入等级权重'));
            } else if (Number(value) <= 0) {
              callback(new Error('等级权重必须大于0'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        // icon: [
        //   { required: true, message: '请上传等级图标', trigger: 'blur' }
        // ],
        // benefitImage: [
        //   { required: true, message: '请上传等级权益图', trigger: 'blur' }
        // ],
        // upgradeModel: [
        //   { required: true, message: '请选择条件模式', trigger: 'change' }
        // ],
        // upgradeTips: [
        //   { required: true, message: '请输入升级条件说明文字', trigger: 'blur' }
        // ],

        selfRate: [{
          required: true,
          message: '请输入自购分佣比例',
          trigger: 'blur'
        }],
        subRate: [{
          required: true,
          message: '请输入平台补贴比例',
          trigger: 'blur'
        }],
        directRate: [{
          required: true,
          message: '请输入直属分佣比例',
          trigger: 'blur'
        }],
        // teamRate: [
        //   { required: true, message: '请输入团队比例比例', trigger: 'blur' }
        // ],
        // teamPlusRate: [
        //   { required: true, message: '请输入团队比例比例', trigger: 'blur' }
        // ],
        plusModel: [{
          required: true,
          message: '请选择分佣模式',
          trigger: 'change'
        }],
        teamShare: [{
          required: true,
          message: '请选择团队分佣模式',
          trigger: 'change'
        }],
        targetGrade: [{
          required: true,
          message: '请选择升级至哪一等级',
          trigger: 'change'
        }]
      },
      modelRules: [{
        required: true,
        message: '请选择条件模式',
        trigger: 'change'
      }],
      isExceed: false,
      dialogImageUrl: '',
      // url展示

      // 删除弹窗
      delDialogVisible: false,
      addIsRenewal: 'add',
      // 操作类型（添加and编辑）
      // nameListData: [], // 过滤数组
      // appId: 101
      gradeOptions: []
    };
  },
  computed: {
    editOptions: function editOptions() {
      var _this = this;
      if (this.ruleForm.grade) {
        return this.gradeOptions.filter(function (item) {
          return item.grade > _this.ruleForm.grade;
        });
      } else {
        return [];
      }
    }
  },
  mounted: function mounted() {
    this.memberQueryMemberGradeApi();
    this.listClassSetApi();
    this.queryTermType(1);
    this.queryTermType(2);
    this.queryTermType(3);
    this.queryTermType(4);
    var tbody = document.querySelector('.my_table_name .el-table__body-wrapper tbody');
    // console.log('tbody', tbody)
    _sortablejs.default.create(tbody, {
      handle: '.handle',
      animation: 150,
      onEnd: function onEnd(_ref) {
        var newIndex = _ref.newIndex,
          oldIndex = _ref.oldIndex;
      } // console.log('id', this.tableData[oldIndex].grade, newIndex)
      // this.moveClassSetApi(this.tableData[oldIndex].grade, newIndex)
    });
  },
  methods: {
    onProhibitedUpgrade: function onProhibitedUpgrade() {
      this.ruleForm.selfUpgrade = 0;
      this.ruleForm.upgradeMethod = 0;
      this.ruleForm.targetGrade = null;
    },
    onChangeGrade: function onChangeGrade(val) {
      this.ruleForm.targetGrade = null;
    },
    // 等级列表
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context.v;
              this.gradeOptions = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    // 列表
    listClassSetApi: function () {
      var _listClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              this.tableLoading = true;
              params = {};
              _context2.n = 1;
              return (0, _dispositionl.listClassSetApi)(params);
            case 1:
              res = _context2.v;
              this.tableLoading = false;
              if (res.code === 0) {
                this.tableData = res.data;
                // console.log('tableData', this.tableData)
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function listClassSetApi() {
        return _listClassSetApi2.apply(this, arguments);
      }
      return listClassSetApi;
    }(),
    // 新增---------------------------------------
    // 添加
    onAddAllocation: function onAddAllocation() {
      // this.listClassSetApi()
      this.queryTermType(1);
      // this.queryTermType(2)
      // this.queryTermType(3)
      // this.queryTermType(4)
      this.addIsRenewal = 'add';
      this.dialogVisible = true;
    },
    // 关闭弹窗
    close: function close() {
      this.dialogVisible = false;
      this.resetForm();
    },
    onRequest: function () {
      var _onRequest = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(_ref2) {
        var file, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              file = _ref2.file;
              _context3.n = 1;
              return (0, _ossUpload.uploadOSS)(file);
            case 1:
              res = _context3.v;
              this.ruleForm.icon = res;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onRequest(_x) {
        return _onRequest.apply(this, arguments);
      }
      return onRequest;
    }(),
    onRequest1: function () {
      var _onRequest2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(_ref3) {
        var file, res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              file = _ref3.file;
              _context4.n = 1;
              return (0, _ossUpload.uploadOSS)(file);
            case 1:
              res = _context4.v;
              this.ruleForm.benefitImage = res;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onRequest1(_x2) {
        return _onRequest2.apply(this, arguments);
      }
      return onRequest1;
    }(),
    // 条件过滤
    ConditionalFiltering: function ConditionalFiltering(k, termList) {
      var count = termList.filter(function (item) {
        return item.type === 4;
      }).length;
      this.conditionTrueIsNoList[k + 1] = count >= 2;
      // 条件模式: 0-同时 1-任意
      if (count >= 2) {
        this.ruleForm.conditionList[k].model = 1;
      }
    },
    onAddConditions: function () {
      var _onAddConditions = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(k, item) {
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              // const data = await this.queryTermType(item.id)
              if (!this.ruleForm.conditionList[k].termList) {
                this.ruleForm.conditionList[k].termList = [];
              }
              this.ruleForm.conditionList[k].termList.push((0, _objectSpread2.default)({}, this.ConditionType[item.id]));
              // console.log('this.ruleForm.conditionList', this.ruleForm.conditionList)
              // this.ruleForm.conditionList[k].termList.push({ ...this.ConditionType[data.termType], itemLimit: data.itemLimit, relationLimit: data.relationLimit, timeLimit: data.timeLimit })
              this.ConditionalFiltering(k, this.ruleForm.conditionList[k].termList);
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onAddConditions(_x3, _x4) {
        return _onAddConditions.apply(this, arguments);
      }
      return onAddConditions;
    }(),
    queryTermType: function () {
      var _queryTermType2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(termType) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                // appId: 101,
                termType: termType
              };
              _context6.n = 1;
              return (0, _dispositionl.queryTermType)(params);
            case 1:
              res = _context6.v;
              if (termType === 1) {
                this.selectData.userData.itemLimit = res.data.itemLimit;
                this.selectData.userData.relationLimit = res.data.relationLimit;
                this.selectData.userData.timeLimit = res.data.timeLimit;
              } else if (termType === 2) {
                this.selectData.orderData.itemLimit = res.data.itemLimit;
                this.selectData.orderData.relationLimit = res.data.relationLimit;
                this.selectData.orderData.timeLimit = res.data.timeLimit;
              } else if (termType === 3) {
                this.selectData.earningsData.itemLimit = res.data.itemLimit;
                this.selectData.earningsData.relationLimit = res.data.relationLimit;
                this.selectData.earningsData.timeLimit = res.data.timeLimit;
              } else if (termType === 4) {
                this.selectData.topUpData.itemLimit = res.data.itemLimit;
                this.selectData.topUpData.relationLimit = res.data.relationLimit;
                this.selectData.topUpData.timeLimit = res.data.timeLimit;
              }
              // console.log('selectData', this.selectData)
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t3 = _context6.v;
              console.log(_t3);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function queryTermType(_x5) {
        return _queryTermType2.apply(this, arguments);
      }
      return queryTermType;
    }(),
    onDeleteConditions: function onDeleteConditions(k, index) {
      this.ruleForm.conditionList[k].termList.splice(index, 1);
      this.ConditionalFiltering(k, this.ruleForm.conditionList[k].termList);
    },
    // 表单提交
    submitForm: function submitForm(formName) {
      var _this2 = this;
      var hasEmptyRate = this.ruleForm.lateralRateList.some(function (i) {
        return i.rate === '' || i.rate === null || i.rate === undefined || Number(i.rate) < 0;
      });
      if (hasEmptyRate) {
        this.$message('请填写 团队分佣比例配置1 下的各个平级奖的比例（最少设置为0)');
        return false;
      }
      // 判断 lateralPlusRateList 是否有 rate 为空
      var hasEmptyPlusRate = this.ruleForm.lateralPlusRateList.some(function (i) {
        return i.rate === '' || i.rate === null || i.rate === undefined || Number(i.rate) < 0;
      });
      if (hasEmptyPlusRate) {
        this.$message('请填写 团队分佣比例配置2 下的各个平级奖的比例（最少设置为0)');
        return false;
      }
      if (Number(this.ruleForm.selfRate) > 100) {
        this.isExceed = true;
        return false;
      } else {
        this.isExceed = false;
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this2.addIsRenewal === 'add') {
            _this2.$confirm('是否确认添加等级配置?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this2.saveClassSetApi();
            });
          } else {
            _this2.$confirm('是否确认修改此等级配置?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this2.updateClassSetApi();
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // ------**************************************------------------
    // 编辑
    onEditor: function onEditor(data) {
      // this.listClassSetApi()
      this.queryTermType(1);
      // this.queryTermType(2)
      // this.queryTermType(3)
      // this.queryTermType(4)
      this.addIsRenewal = 'renewal';
      this.getClassSetApi(data.gradeId);
      this.dialogVisible = true;
    },
    // 列表删除
    onDelete: function onDelete(data) {
      var _this3 = this;
      // console.log('data', data)
      if (data.status === 0) {
        this.$confirm('当前等级在启用状态，不可删除！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // })
        }).catch(function () {
          _this3.$message({
            type: 'info',
            message: '已取消'
          });
        });
        return false;
      }
      this.$confirm('是否确认要删除该等级?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.deleteClassSetApi(Number(data.gradeId));
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 提示判断
    validateName: function validateName(rule, value, callback) {
      if (!value) {
        return callback(new Error('等级名称不能为空'));
      }
      // if (this.addIsRenewal === 'add') {
      //   if (this.nameListData.includes(value)) {
      //     return callback(new Error('该等级名称已被创建'))
      //   }
      // }

      callback();
    },
    delClose: function delClose() {},
    // 表单重置
    resetForm: function resetForm() {
      var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ruleForm';
      this.$refs[formName].resetFields();
      this.ruleForm = {
        status: 0,
        // 状态
        name: '',
        // 等级名称
        grade: '',
        // 权重
        icon: '',
        // 图片
        selfUpgrade: 1,
        // 用户自助升级 0-不允许 1-允许
        upgradeMethod: 0,
        // 升级方式 0-默认升级 1-自定义升级
        targetGrade: null,
        // 升级的目标等级
        teamShare: null,
        // 团队分佣 0-禁止团队分佣 1-启用团队分佣
        benefitImage: '',
        // 权益图
        upgradeModel: 1,
        // 条件模式
        upgradeTips: '',
        // 说明
        conditionList: [{
          enable: 0,
          index: 1,
          model: null,
          termList: []
        }, {
          enable: 0,
          index: 2,
          model: null,
          termList: []
        }, {
          enable: 0,
          index: 3,
          model: null,
          termList: []
        }],
        selfRate: '',
        // 自购分佣
        subRate: '',
        directRate: null,
        // 直属上级

        teamRate: 0,
        // 团队分佣1
        lateralRateList: [{
          id: 1,
          order: 1,
          // 位置
          rate: 0 // 比例
        }, {
          id: 2,
          order: 2,
          rate: 0
        }, {
          id: 3,
          order: 3,
          rate: 0
        }],
        teamPlusRate: 0,
        // 团队分佣2
        lateralPlusRateList: [{
          id: 4,
          // 索引表示key
          order: 1,
          rate: 0
        }, {
          id: 5,
          order: 2,
          rate: 0
        }, {
          id: 6,
          order: 3,
          rate: 0
        }],
        plusModel: null // 分佣配置模式:0-团队分佣配置1,1-团队分佣配置2
      };
      this.isExceed = false;
    },
    // 添加
    saveClassSetApi: function () {
      var _saveClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              if (this.ruleForm.upgradeModel === 0) {
                delete params.upgradeTips;
                delete params.conditionList;
              }
              // console.log('params-----', params)
              _context7.n = 1;
              return (0, _dispositionl.saveClassSetApi)(params);
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                this.close();
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t4 = _context7.v;
              console.log(_t4);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function saveClassSetApi() {
        return _saveClassSetApi2.apply(this, arguments);
      }
      return saveClassSetApi;
    }(),
    // 删除
    deleteClassSetApi: function () {
      var _deleteClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8(gradeId) {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              params = {
                // userId: 0,
                // appId: this.appId,
                gradeId: gradeId
              };
              _context8.n = 1;
              return (0, _dispositionl.deleteClassSetApi)(params);
            case 1:
              res = _context8.v;
              if (res.code === 0) {
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
              }
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t5 = _context8.v;
              console.log(_t5);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function deleteClassSetApi(_x6) {
        return _deleteClassSetApi2.apply(this, arguments);
      }
      return deleteClassSetApi;
    }(),
    // 详情
    getClassSetApi: function () {
      var _getClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9(gradeId) {
        var params, res, data, _t6;
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              params = {
                gradeId: gradeId
              };
              _context9.n = 1;
              return (0, _dispositionl.getClassSetApi)(params);
            case 1:
              res = _context9.v;
              if (res.code === 0) {
                // res.data.conditionList.forEach(element => {
                //   element.termList.forEach(e => {
                //     console.log('e', e.itemPair.key)
                //     if (e.itemPair) {
                //       e.item = e.itemPair.key
                //       delete e.itemPair
                //     }
                //     if (e.relaPair) {
                //       e.rela = e.relaPair.key
                //       delete e.relaPair
                //     }
                //     if (e.timePair) {
                //       e.time = e.timePair.key
                //       delete e.timePair
                //     }
                //   })
                // })
                // this.ruleForm = res.data
                data = JSON.parse(JSON.stringify(res.data));
                data.upgradeMethod = Number(data.upgradeMethod);
                data.targetGrade = Number(data.targetGrade) ? Number(data.targetGrade) : null;
                data.conditionList.forEach(function (condition) {
                  if (condition.termList && condition.termList.length > 0) {
                    condition.termList = condition.termList.map(function (term) {
                      var newTerm = (0, _objectSpread2.default)({}, term);
                      // 转换itemPair
                      if (newTerm.itemPair) {
                        newTerm.item = newTerm.itemPair.key;
                        delete newTerm.itemPair;
                      } else {
                        newTerm.item = null;
                      }
                      // 转换relaPair
                      if (newTerm.relaPair) {
                        newTerm.rela = newTerm.relaPair.key;
                        delete newTerm.relaPair;
                      } else {
                        newTerm.rela = null;
                      }
                      // 转换timePair
                      if (newTerm.timePair) {
                        newTerm.time = newTerm.timePair.key;
                        delete newTerm.timePair;
                      } else {
                        newTerm.time = null;
                      }
                      return newTerm;
                    });
                  }
                });
                this.ruleForm = data;
              }
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t6 = _context9.v;
              console.log(_t6);
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function getClassSetApi(_x7) {
        return _getClassSetApi2.apply(this, arguments);
      }
      return getClassSetApi;
    }(),
    // 更新
    updateClassSetApi: function () {
      var _updateClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0() {
        var params, res, _t7;
        return (0, _regenerator2.default)().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              if (this.ruleForm.upgradeModel === 0) {
                delete params.upgradeTips;
                delete params.conditionList;
                // params.upgradeTips = ''
                // params.conditionList =
              }
              _context0.n = 1;
              return (0, _dispositionl.updateClassSetApi)(params);
            case 1:
              res = _context0.v;
              if (res.code === 0) {
                this.close();
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
              }
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t7 = _context0.v;
              console.log(_t7);
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this, [[0, 2]]);
      }));
      function updateClassSetApi() {
        return _updateClassSetApi2.apply(this, arguments);
      }
      return updateClassSetApi;
    }(),
    // 拖拽
    moveClassSetApi: function () {
      var _moveClassSetApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee1(grade, targetGrade) {
        var params, res, _t8;
        return (0, _regenerator2.default)().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              params = {
                // appId: this.appId,
                grade: grade,
                targetGrade: Number(targetGrade + 1)
              };
              _context1.n = 1;
              return (0, _dispositionl.moveClassSetApi)(params);
            case 1:
              res = _context1.v;
              if (res.code === 0) {
                this.listClassSetApi();
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
              }
              _context1.n = 3;
              break;
            case 2:
              _context1.p = 2;
              _t8 = _context1.v;
              console.log(_t8);
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function moveClassSetApi(_x8, _x9) {
        return _moveClassSetApi2.apply(this, arguments);
      }
      return moveClassSetApi;
    }()
  }
};